import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import SectionLabel from '@/components/ui/SectionLabel'
import PredicationCard from './PredicationCard'
import PredicationCardSkeleton from '@/components/PredicationCardSkeleton'
import { useContent } from '@/hooks/useContent'
import { plusRecentesDabord } from '@/helpers/date'

export default function PredicationSection() {
  const { predications, etatContenu } = useContent()
  const dernieres = plusRecentesDabord(predications).slice(0, 4)

  // Rien à montrer (liste vide, ou serveur injoignable sans cache) : la section s'efface
  // plutôt que d'afficher une erreur au milieu de la page d'accueil.
  if (dernieres.length === 0 && etatContenu !== 'chargement') return null

  return (
    <section id="predication" className="py-16 md:py-20 px-4 bg-cmp-cream">
      <div className="max-w-lg md:max-w-5xl mx-auto">
        <SectionLabel>Prédications</SectionLabel>
        <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy text-center mt-3 mb-8 md:mb-10">
          Nos dernières prédications
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {dernieres.length === 0
            ? [0, 1, 2, 3].map((i) => <PredicationCardSkeleton key={i} />)
            : dernieres.map((predication) => <PredicationCard key={predication.id} {...predication} />)}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/predications"
            className="inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
          >
            Toutes les prédications
            <ChevronRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  )
}
